module.exports = __webpack_public_path__ + "static/media/img1-1.3271663f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/nogal/nutricheck_foliar/FE/img1-1.png
// module id = 1921
// module chunks = 3